import { TextField as TextFieldBase } from '@mui/material';

import { normalizeSx } from '@/shared/lib/normalizeSx';

/**
 * Compact themed text field for dense, inline contexts
 */
const compactSx = {
  '& .MuiInputBase-input': {
    paddingTop: '7px',
    paddingBottom: '7px'
  },
  // Validation text floats below the field so an error never widens or reflows
  // the dense inline layout these fields live in.
  '& .MuiFormHelperText-root': {
    position: 'absolute',
    marginLeft: 0,
    bottom: '-22px',
    fontSize: '12px',
    width: 150
  }
};

type CompactTextFieldProps = React.ComponentProps<typeof TextFieldBase>;

const CompactTextField = ({ sx, size = 'small', ...props }: CompactTextFieldProps) => {
  const sxArray = normalizeSx(sx);
  return (
    <TextFieldBase
      {...props}
      size={size}
      sx={[compactSx, ...sxArray]}
    />
  );
};

export default CompactTextField;
